// import React, { useState } from 'react';
// import { DataGrid } from '@mui/x-data-grid';
// import Skeleton from '@mui/material/Skeleton';
// import IconButton from '@mui/material/IconButton';
// import { v4 as uuidv4 } from 'uuid';
// import GenericDrawer from './genericDrawer';

// const TableWithLoadingWrapper = ({
//   columns,
//   dataSource,
//   loading = false,
//   numLoadingEntries = 3,
//   checkboxSelection = false,
//   pageSize = 10,
//   sortModel = [],
//   selectionModel = [],
//   getRowId = null,
//   expandable = null,
//   onRowSelectionModelChange = null,
// }) => {
//   const [expandedRows, setExpandedRows] = useState({});

//   // Create loading skeleton rows
//   const loadingData = Array(numLoadingEntries).fill().map(() => {
//     const uniqueId = `loading-${uuidv4()}`;
//     return {
//       key: uniqueId,
//       id: uniqueId,
//       isLoading: true,
//     };
//   });

//   const combinedDataSource = loading ? [...loadingData, ...(dataSource || [])] : dataSource;

//   const handleExpandClick = (id) => {
//     setExpandedRows((prev) => ({
//       ...prev,
//       [id]: !prev[id],
//     }));
//   };

//   let adjustedColumns = columns.map((col) => ({
//     ...col,
//     renderCell: (params) => {
//       if (params.row.isLoading) {
//         return <Skeleton variant="text" />;
//       }
//       return col.renderCell ? col.renderCell(params) : params.value;
//     },
//   }));

//   if (expandable) {
//     const expandColumn = {
//       field: 'expand',
//       headerName: '',
//       sortable: false,
//       renderCell: (params) => {
//         const { expandIcon } = expandable;
//         return expandIcon ? expandIcon({
//           expanded: !!expandedRows[params.id],
//           onExpand: () => handleExpandClick(params.id),
//           record: params.row,
//         }) : (
//           <IconButton
//             size="small"
//             onClick={() => handleExpandClick(params.id)}
//             disabled={params.row.isLoading}
//           >
//             {expandedRows[params.id] ? '-' : '+'}
//           </IconButton>
//         );
//       },
//       flex: 0.1,
//     };

//     const { expandIconColumnIndex } = expandable;
//     adjustedColumns = [
//       ...adjustedColumns.slice(0, expandIconColumnIndex),
//       expandColumn,
//       ...adjustedColumns.slice(expandIconColumnIndex),
//     ];
//   }

//   return (
//     <div style={{ width: '100%' }}>
//       <DataGrid
//         rows={combinedDataSource}
//         columns={adjustedColumns}
//         pageSize={pageSize}
//         rowsPerPageOptions={[pageSize]}
//         checkboxSelection={checkboxSelection}
//         disableSelectionOnClick
//         autoHeight
//         initialState={{
//           sorting: {
//             sortModel: sortModel,
//           },
//         }}
//         sx={{
//           fontSize: 14,
//           "& .MuiDataGrid-cell:focus-within": {
//             outline: "none",
//           },
//         }}
//         getRowId={getRowId}
//         selectionModel={selectionModel}
//         keepNonExistentRowsSelected
//         onRowSelectionModelChange={onRowSelectionModelChange}
//       />
//       {expandable && <GenericDrawer
//         open={true}
//         onClose={handleClose}
//         title="Sample Drawer"
//         content="This is some example content inside the drawer. Modify it as needed."
//         onAction1={handleAction1}
//         onAction2={handleAction2}
//         action1Label="Cancel"
//         action2Label="Save"
//       />}
//     </div>
//   );
// };

// export default TableWithLoadingWrapper;

import React, { useState } from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import { IconButton, Skeleton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { v4 as uuidv4 } from "uuid";
import GenericDrawer from "./genericDrawer";
import { Box, Button } from '@mui/material';
import { Spin } from "antd";
import LinearWithValueLabel from "./linearProgressBar";
const TableWithLoadingWrapper = ({
  columns,
  dataSource,
  loading = false,
  numLoadingEntries = 3,
  checkboxSelection = false,
  pageSize = 10,
  sortModel = [],
  pagination,
  pageSizeOptions,
  selectionModel = [],
  getRowId = null,
  onRowSelectionModelChange = null,
  hideFooter = false,
  hideHeader = false,
  enableExpandable = false,
  onRowClick = null,
  transactionDrawer,
  drawerWidth = 300,
  footerFn,
  loadMore,
  disableLoadMore,
  onLoadMore,
  // getRowHeight,
  numerator,
  denominator,
  optInRowHeightAuto, // expand row height 
  noRowsLabel = 'No rows',
}) => {
  const [drawerState, setDrawerState] = useState({ open: false, rowData: null });
  const [expandedRowIds, setExpandedRowIds] = useState([]);

  let adjustedColumns = columns.map((col) => ({
    ...col,
    renderCell: (params) => {
      if (params.row.isLoading) {
        return <Skeleton variant="text" />;
      }
      return col.renderCell ? col.renderCell(params) : params.value;
    },
  }));

  if (optInRowHeightAuto) {

    const iconColumn = {
      field: "plusIcon",
      headerName: "",
      width: 50,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        if (params.row.isLoading) {
          return (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              height="100%"
              width="100%"
            >
              <Skeleton variant="circular" width={24} height={24} />
            </Box>
          );
        }

        const isExpanded = expandedRowIds.includes(params.row.id);

        return (
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              setExpandedRowIds((prev) =>
                isExpanded
                  ? prev.filter((id) => id !== params.row.id)
                  : [...prev, params.row.id]
              );
            }}
          >
            {isExpanded ? <RemoveIcon fontSize="small" /> : <AddIcon fontSize="small" />}
          </IconButton>
        );
      },
    };
    adjustedColumns = [iconColumn, ...adjustedColumns];
  }

  // Create loading skeleton rows
  const loadingData = Array(numLoadingEntries)
    .fill()
    .map(() => {
      const uniqueId = `loading-${uuidv4()}`;
      return {
        key: uniqueId,
        id: uniqueId,
        isLoading: true,
      };
    });

  const combinedDataSource = loading ? [...loadingData, ...(dataSource || [])] : dataSource;

  const handleExpandClick = (rowData) => {
    setDrawerState({ open: true, rowData });
  };

  const handleDrawerClose = () => {
    setDrawerState({ open: false, rowData: null });
  };

  const getRowHeight = (params) => {
    if (params.model.isLoading) return 52;
    return expandedRowIds.includes(params.id) ? "auto" : 52;
  };

  // let adjustedColumns = columns.map((col) => ({
  //   ...col,
  //   renderCell: (params) => {
  //     if (params.row.isLoading) {
  //       return <Skeleton variant="text" />;
  //     }
  //     return col.renderCell ? col.renderCell(params) : params.value;
  //   },
  // }));

  return (
    <div style={{ width: "100%" }}>
      {(numerator !== undefined && denominator !== undefined) ? (
        <LinearWithValueLabel numerator={Math.min(numerator)} denominator={denominator || 1} />
      ) : null}
      <DataGrid
        rows={combinedDataSource}
        columns={adjustedColumns}
        pageSize={pageSize}
        getRowClassName={(params) => expandedRowIds.includes(params.id) ? "expanded-row" : ""}
        rowsPerPageOptions={[pageSize]}
        checkboxSelection={checkboxSelection}
        disableSelectionOnClick
        autoHeight
        initialState={{
          sorting: {
            sortModel: sortModel,
          },
          pagination: pagination
        }}
        pageSizeOptions={pageSizeOptions}
        sx={{
          fontSize: 14,
          "& .MuiDataGrid-cell:focus-within": {
            outline: "none",
          },
          "& .MuiDataGrid-row:hover": {
            cursor: enableExpandable ? "pointer" : "default",
            backgroundColor: "rgba(0, 0, 0, 0.04)",
          },
          "& .MuiTablePagination-selectLabel": {
            margin: "14px 0px",
          },
          "& .MuiTablePagination-displayedRows": {
            margin: "14px 0px"
          },
          "& .MuiInputBase-root-MuiTablePagination-select": {
            fontSize: "13px !important",
          },
          "& .MuiTablePagination-input": {
            fontSize: "13px !important",
          },
          "& .expanded-row .MuiDataGrid-cell": {
            paddingTop: 1,
            paddingBottom: 1,
          }
        }}
        getRowId={getRowId}
        getRowHeight={getRowHeight}
        selectionModel={selectionModel}
        keepNonExistentRowsSelected
        onRowSelectionModelChange={onRowSelectionModelChange}
        hideFooter={hideFooter}
        columnHeaderHeight={hideHeader ? 0 : 56} // default value is 56 in MUI docs https://mui.com/x/api/data-grid/data-grid/
        onRowClick={(params) => {
          if (enableExpandable) {
            handleExpandClick(params.row);
          }
          if (onRowClick) {
            onRowClick(params.row); // Call the onRow function with the clicked row's data
          }
        }}
        localeText={{ noRowsLabel: noRowsLabel }} // Set placeholder for no rows
      />
      <div>
        {footerFn}
      </div>

      {loadMore && (
        <div style={{ textAlign: "center", marginTop: 16 }}>
          <Button
            variant="contained"
            onClick={onLoadMore}
            disabled={disableLoadMore}
            size="medium"
            sx={{ fontSize: 12, fontWeight: 'bold' }}
          >
            {loading ? <Spin /> : "Load More"}
          </Button>
        </div>
      )}
      {/* Drawer for Row Details */}
      {enableExpandable && drawerState.open && (
        <GenericDrawer
          open={drawerState.open}
          onClose={handleDrawerClose}
          content={transactionDrawer}
          width={drawerWidth}
          onAction1={handleDrawerClose}
          action1Label="Close"
        />
      )}
    </div>
  );
};

export default TableWithLoadingWrapper;